module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-hans-klessing-huette-9fb96bbf3cf0db496d972d57eefde173.jpg";